import React from 'react';
import { useExperiments } from '@wix/wix-experiments-react';
import { GlobalDesignGroupActionPanel } from '../types';
import { useGlobalDesignStyles } from '../common/abstractStyles';
import { StylePresets } from '../common/presets/StylePresets';
import { Box } from '@wix/design-system';
import { getMostSpecificValueFromDecomposed } from '../../../apis/services/editActionsServices/nativeActions/globalDesign/common/decomposer';
import { StylesDerivedNativeActions } from '@wix/editor-platform-host-integration-apis';
import { useBI } from '../hooks/useBI';
import { GD_WDS_EXPERIMENT } from '../experiments';
import { useTranslation } from '../..';
import { GLOBAL_DESIGN_TRANSLATION_KEYS } from '../constants';
import { getCurrentDecomposedValues } from '../common/abstractStyles/decompositionUtils';

const FilterControlsPS = React.lazy(() => import('./FilterControlsPS'));

const FilterControls = React.lazy(() => import('./FilterControls'));

const FilterStyles: GlobalDesignGroupActionPanel = (props) => {
  const { experiments } = useExperiments({ readOnly: true });
  const isWDS = experiments.enabled(GD_WDS_EXPERIMENT);
  const [t] = useTranslation();

  const { trackPresetApply } = useBI();
  const { values, updateStyles, isLoading } = useGlobalDesignStyles(
    props.host,
    'filterStyles',
    props.componentsAPI,
    { withVariablesResolution: true },
  );

  if (isLoading || !values) {
    return <div>{t(GLOBAL_DESIGN_TRANSLATION_KEYS.LOADING)}</div>;
  }

  const currentDecomposed = getCurrentDecomposedValues(values);

  const handlePresetApplied = async (presetId: string) => {
    const newValues = props.stylePresets?.find(
      (preset) => preset.id === presetId,
    )?.values;

    if (newValues) {
      trackPresetApply(StylesDerivedNativeActions.filterStyles, {
        prevValues: JSON.stringify(
          getMostSpecificValueFromDecomposed(currentDecomposed),
        ),
        newValues: JSON.stringify(newValues),
        targetComponents: props.group.metadata.targetComponents,
      });
      await updateStyles(newValues);
      await props.onPresetApplied?.(presetId);
    }
  };

  return (
    <Box direction="vertical" width="100%" gap="SP4">
      {props.stylePresets && props.stylePresets.length > 0 && (
        <StylePresets
          errorMessagePrefix="filter preset"
          presets={props.stylePresets}
          metadata={values.metadata}
          currentDecomposed={currentDecomposed}
          onPresetApplied={handlePresetApplied}
        />
      )}

      {isWDS ? (
        <FilterControls
          metadata={props.group.metadata}
          values={values}
          updateStyles={updateStyles}
        />
      ) : (
        <FilterControlsPS
          host={props.host}
          metadata={props.group.metadata}
          values={values}
          updateStyles={updateStyles}
        />
      )}
    </Box>
  );
};

export default FilterStyles;
